import { lazy, ReactElement, Suspense } from "react";
import { LoadingIndicator } from "@/components-v2/LoadingIndicator";
import type { DataGraphProps } from "./dataGraphDomain";

const loadDataGraphView = () => import("./view/DataGraphView");

const DataGraphView = lazy(loadDataGraphView);

// Fetches the graph chunk before it is rendered, so a page can load it while it waits for its data.
export const preloadDataGraph = (): void => void loadDataGraphView();

// lazy() cannot carry the generics, and the view only passes node and edge values through.
export function DataGraph<N, E>(props: DataGraphProps<N, E>): ReactElement {
  return (
    <Suspense
      fallback={
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          {props.panels?.top}
          <LoadingIndicator fullscreen />
        </div>
      }
    >
      <DataGraphView {...(props as DataGraphProps<unknown, unknown>)} />
    </Suspense>
  );
}
